import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { IS_NOT_CHECKED_AGREEMENT } from "../../callbackRequest/constants";
import { getAddress } from "../../common/actions/getAddress";
import { ERROR_TYPES } from "../../constants";
import { ADDRESS_BLOCK_VIEW_STATUSES } from "./constants";
import { checkConnectionAndTariffs } from "./actions/checkConnectionAndTariffs";
import { submitCallbackRequest } from "../../callbackRequest/actions/submitCallbackRequest";
import { mapResponseStatusOnStep } from "./utils";
var initialState = {
  status: ADDRESS_BLOCK_VIEW_STATUSES.checkAddress,
  addressSuggestions: [],
  isError: false,
  isLoading: false,
  selectedAddress: null,
  isAddressError: false,
  isCheckboxError: false
};
export var addressVerificationSlice = createSlice({
  name: 'addressVerification',
  initialState: initialState,
  reducers: {
    setLoading: function setLoading(state, _ref) {
      var payload = _ref.payload;
      state.isLoading = payload;
    },
    setSelectedAddress: function setSelectedAddress(state, _ref2) {
      var payload = _ref2.payload;
      state.selectedAddress = payload;
    },
    setIsAddressErrorStatus: function setIsAddressErrorStatus(state, _ref3) {
      var payload = _ref3.payload;
      state.isAddressError = payload;
    },
    backToCheckAddressStep: function backToCheckAddressStep(state) {
      state.addressSuggestions = [];
      state.status = ADDRESS_BLOCK_VIEW_STATUSES.checkAddress;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(getAddress.fulfilled, function (state, _ref4) {
      var payload = _ref4.payload;
      state.addressSuggestions = payload;
    }).addCase(getAddress.rejected, function (state, _ref5) {
      var payload = _ref5.payload;
      state.isError = !(payload === ERROR_TYPES.cancel);
    }).addCase(checkConnectionAndTariffs.fulfilled, function (state, _ref6) {
      var payload = _ref6.payload;
      var connectionStatus = payload.connectionStatus,
        isRedirect = payload.isRedirect;
      if (isRedirect) return;
      state.isLoading = false;
      state.status = mapResponseStatusOnStep(connectionStatus);
    }).addCase(submitCallbackRequest.fulfilled, function (state, _ref7) {
      var payload = _ref7.payload;
      state.isLoading = false;
      state.isCheckboxError = false;
      if (payload.isSucceeded) {
        state.status = ADDRESS_BLOCK_VIEW_STATUSES.success;
      }
    }).addCase(checkConnectionAndTariffs.rejected, function (state, _ref8) {
      var payload = _ref8.payload;
      state.isLoading = false;
      if (payload === ERROR_TYPES.emptyAddress) {
        state.isAddressError = true;
        return;
      }
      state.status = ADDRESS_BLOCK_VIEW_STATUSES.isNotAvailable;
    }).addCase(submitCallbackRequest.rejected, function (state, _ref9) {
      var payload = _ref9.payload;
      state.isLoading = false;
      if (payload === IS_NOT_CHECKED_AGREEMENT) state.isCheckboxError = true;
    }).addMatcher(isAnyOf(submitCallbackRequest.pending, checkConnectionAndTariffs.pending), function (state) {
      state.isLoading = true;
    });
  }
});
var _addressVerificationS = addressVerificationSlice.actions,
  backToCheckAddressStep = _addressVerificationS.backToCheckAddressStep,
  setLoading = _addressVerificationS.setLoading,
  setSelectedAddress = _addressVerificationS.setSelectedAddress,
  setIsAddressErrorStatus = _addressVerificationS.setIsAddressErrorStatus;
export { backToCheckAddressStep, setLoading, setSelectedAddress, setIsAddressErrorStatus };
export var addressVerificationReducer = addressVerificationSlice.reducer;